import React from 'react';
import useStoresTable from './useStoresTable';
import { Colors } from '../../../../../utils/colors';
import { useTranslation } from 'react-i18next';
import { LeftSideMenu } from '../../../../../components/LeftMenu/LeftMenu';
import { Header } from '../../../../../components/Header/Header';
import AdminTable from '../../../components/AdminTable';
import AddStore from '../../../components/modals/AddStore';
import AddNewButton from '../../../components/AddNewButton';
import SearchInput from '../../../components/SearchInput';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import ROUTES, {
  getStoreInfoLink,
  getUserInfoLink,
} from '../../../../../routes/route';

function MallStoresTable() {
  const {
    stores,
    searchText,
    isModalVisible,
    setIsModalVisible,
    setSearchText,
    onStoreCreated,
    mall,
    pagination,
    onPageChange,
  } = useStoresTable();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const storesColumns = [
    {
      title: 'Nº',
      dataIndex: 'index',
      render: (text) => <span className='adminTable__grey'>{text}</span>,
      width: 60,
    },
    {
      title: t('adminTable.storeName'),
      dataIndex: 'name',
      sorter: (a, b) => a.name.localeCompare(b.name),
      render: (text, record) => (
        <div>
          <Link to={getStoreInfoLink(record.id)}>{text}</Link>
        </div>
      ),
      width: 140,
    },
    {
      title: t('adminTable.mall'),
      dataIndex: 'mall',
      render: (text) => <div>{text}</div>,
      width: 240,
    },
    {
      title: t('adminTable.storeManager'),
      dataIndex: 'storeManager',
      render: (text, record) => (
        <div>
          {text ? (
            <Link to={getUserInfoLink(record.storeManagerId)}>{text}</Link>
          ) : (
            '-'
          )}
        </div>
      ),
      width: 240,
    },
    {
      title: t('adminTable.status'),
      dataIndex: 'closed',
      render: (closed) => (
        <div>{closed ? t('adminTable.closed') : t('adminTable.active')}</div>
      ),
      width: 90,
    },
    {
      title: t('adminTable.tax'),
      dataIndex: 'tax',
      sorter: (a, b) => a.tax.localeCompare(b.tax),
      render: (text) => <div>{t(text.toLowerCase())}</div>,
      width: 90,
    },
  ];

  console.log({ stores });

  return (
    <>
      <Header
        goBack={{
          title: t('mall'),
          onClick: () => navigate(ROUTES.ADMIN.MALLS.LIST),
        }}
      />
      <AddStore
        isOpen={isModalVisible}
        close={() => setIsModalVisible(false)}
        mall={mall}
        onStoreCreated={onStoreCreated}
      />
      <div
        className='mainContainer'
        style={{ backgroundColor: Colors.mainBlack }}
      >
        <LeftSideMenu selected='ADMIN' />
        <div style={{ marginLeft: 12, width: 'calc(100% - 60px)' }}>
          <AdminTable
            columns={storesColumns}
            dataSource={stores}
            pagination={pagination}
            onPaginationChange={onPageChange}
            header={
              <div style={{ margin: '16px 0' }}>
                <div className='adminTable__header'>
                  <h2>{mall?.name}</h2>
                  <AddNewButton
                    text={t('add_New_Store')}
                    onClick={() => setIsModalVisible(true)}
                  />
                </div>
                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                  <SearchInput value={searchText} onChange={setSearchText} />
                </div>
              </div>
            }
          />
        </div>
      </div>
    </>
  );
}

export default MallStoresTable;
